import React, { useEffect, useState , useContext, useRef } from "react";
import { useParams, useHistory } from "react-router-dom";
import Input from "../../shared/components/formElements/Input";
import Button from "../../shared/components/formElements/Button";
import Card from "../../shared/components/UIElements/Card";
import LoadingSpinner from "../../shared/components/UIElements/LoadingSpinner";
import { AuthContext } from '../../shared/context/auth-context';
import Toggle from "../../shared/components/formElements/Toggle";
import ErrorModal from "../../shared/components/UIElements/ErrorModal";
import {
  VALIDATOR_REQUIRE,
  VALIDATOR_MAXLENGTH,
} from "../../shared/util/validators";
import { useForm } from "../../shared/hooks/form-hook";
import { useHttpClient } from "../../shared/hooks/http-hook";
import "./Orders.css";
import OrderList from "../components/OrderList";

const UpdateOrder = () => {
  const auth = useContext(AuthContext);
  const [loadedItems, setLoadedItems] = useState([]);
  const { isLoading, error, sendRequest, clearError } = useHttpClient();
  const orderID = useParams().orderId;
  const [identifiedOrder, setIdentifiedOrder] = useState();
  const history = useHistory();
  // const [taxToggle, setTaxToggle] = useState("undefined")

  const [formState, inputHandler, setFormData] = useForm(
    {
      startDate: {
        value: "",
        isValid: false,
      },
      eventDate: {
        value: "",
        isValid: false,
      },
      description: {
        value: "",
        isValid: false,
      },
      items: {
        value: [],
        isValid: false
      },
      deposit : {
        value: 0,
        isValid: true,
      },
      tax : {
        value: "",
        isValid: false,
      }  
    },
    false
  );

  let responseData  = useRef();
  useEffect(() => {
    const fetchOrder = async () => {
      try {
         responseData.current = await sendRequest(
          process.env.REACT_APP_BACKEND_URL+`/orders/${orderID}`,
          "GET",
          null,
          {  Authorization: 'Bearer '+ auth.token}
        );
        setIdentifiedOrder(responseData.current.order);
        setFormData(
          {
            startDate: {
              value: responseData.current.order.startDate,
              isValid: true,
            },
            eventDate: {
              value: responseData.current.order.eventDate,
              isValid: true,
            },
            description: {
              value: responseData.current.order.description,
              isValid: true,
            },
            items: {
              value: responseData.current.order.items,
              isValid: true
            },
            tax : {
              value: responseData.current.order.tax,
              // value: taxToggle,
              isValid: true,
            },
            deposit : {
              value: responseData.current.order.deposit,
              isValid: true,
            },
          },
          true
        );
      } catch (err) {}
    };
    fetchOrder();
  }, [sendRequest, orderID, setFormData, auth.token]); 


    
  let initialItems = [];

  if(responseData.current) {
    initialItems = responseData.current.order.items.map(any => any[0])
  }

  const intersection = initialItems.filter(x => formState.inputs.items.value.includes(x))
  const deleted = initialItems.filter(x => !intersection.includes(x));
  const added = formState.inputs.items.value.filter(x => !intersection.includes(x));

  const placeUpdateSubmitHandler = async (event) => {
    event.preventDefault();

    const newItems = added.map(item => [item.id, item.quantity])
    newItems.forEach(async item => {
      try {
        await sendRequest(
          process.env.REACT_APP_BACKEND_URL+'/orders/decrement',
          "PATCH",
          JSON.stringify({
            quantity: item[1],
            id: item[0]
          }),
          {
            "Content-Type": "application/json",
            Authorization: 'Bearer '+ auth.token
          }
        );
      } catch (err) {}
    })

    const deletedItems = deleted.map(item => [item.id, item.quantity])
    deletedItems.forEach(async item => {
      try {
        await sendRequest(
          process.env.REACT_APP_BACKEND_URL+'/orders/increment',
          "PATCH",
          JSON.stringify({
            quantity: item[1],
            id: item[0]
          }),
          {
            "Content-Type": "application/json",
            Authorization: 'Bearer '+ auth.token
          }
        );
      } catch (err) {}
    })

    try {
      await sendRequest(
        process.env.REACT_APP_BACKEND_URL+`/orders/${orderID}/edit`,
        "PATCH",
        JSON.stringify({
          startDate: formState.inputs.startDate.value,
          eventDate: formState.inputs.eventDate.value + "T00:00:00.000Z",
          description: formState.inputs.description.value,
          items: formState.inputs.items.value,
          tax: formState.inputs.tax.value
        }),
        {
          "Content-Type": "application/json",
          Authorization: 'Bearer '+ auth.token
        }
      );
      history.push(`/orders/${orderID}`);
    } catch (err) {}
  };

    useEffect(() => {
    const fetchItems = async () => {
      try {
        const responseItemsData = await sendRequest(
          process.env.REACT_APP_BACKEND_URL+"/items",
          "GET",
          null,
          {Authorization: 'Bearer '+ auth.token}
        );
        setLoadedItems(responseItemsData.items);
      } catch (err) {}
    };
    fetchItems();
  }, [sendRequest, auth.token]);


  const fixedStyleItems = loadedItems.map(item => {
    return({
      ...item,
      style : item.style.split("_")[0]
    })
  })

  if (!identifiedOrder && !error) {
    return (
      <div className="center">
        {/* <Card><h6>Could not find the order!</h6></Card> */}
      </div>
    );
  }

  if (isLoading) {
    return (
      <div className="center">
        <LoadingSpinner />
      </div>
    );
  }

  return (
    <React.Fragment>
      <ErrorModal error={error} onClear={clearError} />
      {!isLoading && identifiedOrder && (
        <div className="new-order-list">
          <Card className="order-item__content">

              <div className="flex justify-center">
                <div className=" w-25">
                  <input
                    readOnly
                    type="text"
                    value={identifiedOrder.orderNumber}
                  />
                </div>
                <h2 className="header-text">Edit Sales Receipt</h2>
                <div className=" w-25">
 
                </div>

              </div>
            <form className="place-form" onSubmit={placeUpdateSubmitHandler}>

              {/* <div className="flex justify-center">
                <div className=" w-50 pa2 mr1">
                  <label>Name</label>
                  <input
                    readOnly
                    type="text"
                    value={identifiedOrder.customer.flat()[0].name}
                  />
                </div>
                <div className=" w-50 pa2 mr1">
                  <label>Last Name</label>
                  <input
                    readOnly
                    type="text"
                    value={identifiedOrder.customer.flat()[0].lastname}
                  />
                </div>
                <div className=" w-50 pa2 mr1">
                  <label>Phone</label>
                  <input
                    readOnly
                    type="text"
                    value={identifiedOrder.customer.flat()[0].phone}
                  />
                </div>
              </div> */}
              <div className="flex justify-left">
              <div className=" w-50 pa2 mr1">
                  <label>Order Date</label>
                  <input
                    readOnly
                    type="text"
                    value={identifiedOrder.startDate.substring(0, 10)}
                  />
                </div>
                <div className=" w-50 pa1">
                  <label>
                    Event Date
                  </label>
                  <Input
                    id="eventDate"
                    element="input"
                    type="date"
                    validators={[VALIDATOR_REQUIRE()]}
                    errorText="Please enter a Date."
                    onInput={inputHandler}
                    initialValue={formState.inputs.eventDate.value.split('T')[0]}
                    initialValid={formState.inputs.eventDate.isValid}
                  />
                </div>
                <div style={{marginTop:"41px"}}>              
                <Toggle 
                  label="Tax"
                  onInput={inputHandler}
                  id="tax"
                  initialState={responseData.current.order.tax}
                  />
              </div>
              </div>
              {/* <div className="flex justify-left">
                <div className=" w-100 pa2 mr1">
                  <label>
                    <span>Payment Status: </span>
                    <input
                      // style={{left:"0px", visibility:"visible", position:"relative", margin:"10px"}}
                      className="input-checkbox"
                      type="checkbox"
                      checked={isChecked}
                      onChange={handleOnChange}
                    />
                  </label>
                </div>
              </div> */}


              <div className="mw-100">

              { initialItems.length > 0 &&  <OrderList 
                id="items"
                label="Item"
                onInput={inputHandler}
                type="text"
                suggestionArray={fixedStyleItems}    
                deposit={responseData.current.order.deposit} 
                tax={formState.inputs.tax.value}  
                initialItems={initialItems}
   
              />}
              </div>
              <div className="flex justify-center">
                <div className=" w-100 pa2 mr1">
                  <label>Description</label>
                  <Input
                    id="description"
                    type="text"
                    // label="description"
                    validators={[VALIDATOR_REQUIRE(), VALIDATOR_MAXLENGTH(250)]}
                    errorText="Please enter a description."
                    onInput={inputHandler}
                    initialValue={formState.inputs.description.value}
                    initialValid={formState.inputs.description.isValid}
                  />
                </div>
              </div>
         

              <Button type="submit" disabled={!formState.isValid}>
                UPDATE RECEIPT
              </Button>
              <Button inverse to={`/orders/${orderID}`}>
                CANCEL
              </Button>
            </form>
          </Card>
        </div>
      )}
    </React.Fragment>
  );
};

export default UpdateOrder;
